
  import { Component, Prop } from 'vue-property-decorator';
  import Vue from 'vue';
  import RefDashboardGraph from '@/components/dashboard/ReferenceDashboardGraph.vue';
  import FileCountGraph from '@/components/dashboard/FileCountGraph.vue';
  import { Get } from 'vuex-pathify';
  import MxInfoButton from '@/components/global/MxInfoButton.vue';
  import ProjectFilesTableSmall from '@/components/files/ProjectFilesMatchedTableSmall.vue';
  import PaginatedRequest from '@/models/PaginatedRequest';
  import { IPaginatedRequest } from '@/types/services.types';

  import { IAppInfo, Permission } from '@/types/resource.types';
  
  @Component({
      name: 'MatchedFilesDashboard',
      components: {
        RefDashboardGraph,
        MxInfoButton,
        ProjectFilesTableSmall,
        FileCountGraph
      }
  })
  
  
  export default class v extends Vue {

    initialRequest: IPaginatedRequest | null = null;

    @Get('appInfo')
    readonly appInfo: IAppInfo | null;
      
    showGraph: boolean = false;
    /* Data
    ============================================*/
  
    get canCreateProjects(): boolean {
        return this.$hasPermission(Permission.EditProjects);
    }
    /* Computed
    ============================================*/
    get menuCollapsed(){
      return this.$store?.state?.menuIsCollapsed;
    }
    /* Methods
    ============================================*/
    beforeMount() {
      
      let req = new PaginatedRequest();
        req.orderBy = 'updated';
        req.desc = true;
        req.perPage = 5;
      this.initialRequest = { ...req };
    }

  }
  
  
  